import { supabase } from './lib/supabase';

export async function testSupabaseConnection() {
  console.log('Testing Supabase connection...');
  
  try {
    // Test 1: Check if we can connect at all
    console.log('Test 1: Basic connection');
    const { data: test1, error: error1 } = await supabase
      .from('mosques')
      .select('id')
      .limit(1)
      .single();
    
    console.log('Test 1 result:', { test1, error1 });
    
    // Test 2: Get count
    console.log('Test 2: Count query');
    const { count, error: error2 } = await supabase
      .from('mosques')
      .select('*', { count: 'exact', head: true });
    
    console.log('Test 2 result:', { count, error2 });
    
    // Test 3: Check auth status
    console.log('Test 3: Auth status');
    const { data: { user }, error: error3 } = await supabase.auth.getUser();
    console.log('Test 3 result:', { user: user?.email, error: error3 });
    
  } catch (err) {
    console.error('Test failed:', err);
  }
}

// Run test on window load
if (typeof window !== 'undefined') {
  (window as any).testSupabase = testSupabaseConnection;
}